import {
    REQUEST as req,
    RESPONSE as res,
    PENDING as pend,
    FAILURE as fail,
    CLEAR as clr,
  } from '../../actions/deployments/inference';
  
  const initialState = {
    data: null,
    loading: false,
    error: null,
    // Async (foundation-direct) inference: id of the in-flight job whose
    // result will arrive over the WebSocket. Null for synchronous inferences.
    pendingId: null,
  };
  
  export const reducer = (state = initialState, action) => {
    switch (action.type) {
      case req:
        return {
          ...state,
          loading: true,
          error: null,
          data: null,
          pendingId: null
        };
      case pend:
        // Job accepted; stay in the loading state until the WS completion
        // event resolves it (or the dialog is dismissed).
        return {
          ...state,
          loading: true,
          error: null,
          data: null,
          pendingId: action.payload?.inferenceId || null
        };
      case res:
        return {
          ...state,
          loading: false,
          data: action.payload,
          pendingId: null
        };
      case fail:
        return {
          ...state,
          loading: false,
          error: action.payload,
          pendingId: null
        };
      case clr:
        return {
          ...state,
          data: null,
          loading: false,
          error: null,
          pendingId: null
        };
      default:
        return state;
    }
  };
